import i18next from "i18next";

export const formatNumber = (num: number) => {
  const lang = i18next.language;
  const locale = lang.startsWith("ar") ? "ar-EG" : "en-US";

  return new Intl.NumberFormat(locale, {
    useGrouping: true,
  }).format(num);
};

export const formatPhoneNumber = (phone: string | number) => {
  if (!phone) return "-------";

  // Ensure it's a string
  const phoneStr = phone.toString();

  // Arabic numerals if needed
  if (i18next.language.startsWith("ar")) {
    const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
    return phoneStr.replace(/\d/g, (d) => arabicDigits[parseInt(d)]);
  }

  return phoneStr;
};

export function formatTime(rawTime: string) {
  if (!rawTime) return "-------";

  // Parse the time string as a Date
  const [hours, minutes] = rawTime.split(":").map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0);

  const locale = i18next.language.startsWith("ar") ? "ar-EG" : "en-GB";

  return date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
